<template>
  <div class="kiken">
    <h3>危険手当</h3>
    <div class="multi-date-table" v-for="(item, index) in form.kiken" :key="index">
      <div class="head"><b>危険{{ (index + 1) }}</b></div>
      <div class="item flex">
          <b class="width-55">取得日</b>
          <p>{{ item.shinsei_date }}</p>
      </div>
    </div>
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup() {

    return {
    };
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
